import * as React from 'react'

import './styles.scss'
import Notifications from '../../ScheduleModal/Notifications'
import { Button } from 'components/Form'
import { lang } from 'utils/helpers'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'

const ScheduleNotificationsCard = ({ schedule, onChange, fieldStatus }) => {
  const [scheduleData, setScheduleData] = React.useState(schedule || {})
  const [rangeError, setRangeError] = React.useState({})

  const handleSaveSchedule = () => {
    if (Object.keys(rangeError).length) {
      SaveToastNotification.error()
      return
    }
    onChange({ fieldName: 'schedule', fieldValue: scheduleData })
  }

  return (
    <div className='notifications-card'>
      <div className='title-section'>
        <p className='title'>
          {lang('notifications_view_schedule_card_title')}
        </p>
        <p className='subtitle'>
          {lang('message_out_of_office_schedule_modal_subtitle')}
        </p>
      </div>
      <Notifications
        schedules={[schedule]}
        onChange={setScheduleData}
        setRangeError={setRangeError}
      />
      <Button
        secondary
        value={lang('dashboard_save-schedule')}
        onClick={handleSaveSchedule}
        isSubmitting={fieldStatus.schedule === 'PENDING' ? true : false}
      />
    </div>
  )
}

export default ScheduleNotificationsCard
